import {
  DinerNotificationPreferencesFormData,
  CorporateFormFields,
} from 'src/components/enterprise/features/Corporate/components/Form/types/CorporateForm';

export function transformFormToPayloadDnp(
  dnps: DinerNotificationPreferencesFormData
): string[] {
  return Object.keys(dnps || {}).filter((dnpKey) => dnps[dnpKey]);
}

export function cleanupFormDnpFields(
  formValues: Partial<CorporateFormFields>
): Partial<CorporateFormFields> {
  const { enableDinerNotificationPreferences, ...rest } = formValues;
  return rest;
}

export function transformPayloadToFormDnp(
  dnps: string[]
): DinerNotificationPreferencesFormData {
  return dnps.reduce(
    (prev, restrictionName) => ({
      ...prev,
      [restrictionName]: true,
    }),
    {}
  );
}
